// libs
import React, { memo } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// widgets
import EditButton from '@/widgets/EditButton';
// styles
import styles from '../ReviewCampaign.module.scss';
import ProductChip from '@/widgets/ProductChip/ProductChip';
import ProductDetails from '@/components/ProductDetails/ProductDetails';
const Products = ({ products, setActiveStep }) => {
    const handleEditClick = () => {
        // Index 2 is for Products screen
        setActiveStep(2);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.containerHeaderSub },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Products"),
            React.createElement(EditButton, { label: "Edit", onClick: handleEditClick })),
        React.createElement("div", { className: styles.productsContainer }, products.map((option) => {
            var _a;
            const { creativeId = '-', title = '-', description = '-', } = (_a = option.attributes) !== null && _a !== void 0 ? _a : {};
            return (React.createElement(ProductChip, { key: option.id },
                React.createElement(ProductDetails, { creativeId: creativeId, title: title, subTitle: description })));
        }))));
};
export default memo(Products);
